import { EntryItem, Value } from '@com-delta-omnichannel/aura';
import { ToggleNullValueMocks } from './activity-null-state-value.mocks';

export const ToggleValueMocks: Value[] = ToggleNullValueMocks;

export const ToggleMocks: EntryItem = {
  content: {
    title:
      '<span class="skymiles-landing-page-earns-summary__header">MQD Earning Summary</span>',
    subtitle: ''
  },
  state: '',
  icon: '',
  value: ToggleValueMocks,
  border: 'none',
  ariaLabel: {
    icon: ''
  }
};
